export default __webpack_public_path__ + "static/media/kondor-logo.6cbef0e9.svg";